import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { fetchIntegrations } from "@/lib/api";
import { fill, needsAttention } from "@/lib/connections";
import { S } from "@/lib/strings";

const FIVE_MINUTES = 5 * 60 * 1000;

/** A bar above every page when a connected source needs the user to reconnect it. */
export default function ReconnectBanner() {
  const { data } = useQuery({ queryKey: ["integrations"], queryFn: fetchIntegrations, retry: false, refetchInterval: FIVE_MINUTES });
  const broken = needsAttention(data);
  if (broken.length === 0) return null;
  const names = broken.map((c) => c.display_name).join(", ");

  return (
    <div role="alert" className="flex flex-wrap items-center justify-center gap-3 border-b border-warning/30 bg-warning/10 px-4 py-2 text-sm text-foreground">
      <span className="font-medium">{fill(S.CONN_RECONNECT_BANNER, { name: names })}</span>
      {data?.is_owner ? (
        <Link
          to="/settings?tab=connectors"
          className="rounded-md bg-primary px-3 py-1 text-xs font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
        >
          {S.CONN_RECONNECT_BANNER_CTA}
        </Link>
      ) : (
        <span className="text-xs text-muted-foreground">{S.CONN_OWNER_ONLY}</span>
      )}
    </div>
  );
}
